export default "__VITE_ASSET__edagSiNW__"